import Moment from "moment";
import React, {Component} from "react";
import {SubsidiaryUtils} from "../../../../../../utils/Subsidiary/SubsidiaryUtils";
import {ActionCreator} from "../../../../../../actions/actions";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import {AuthActionCreators} from "../../../../actions/actionCreators";
import {connect} from "react-redux";
import UserAvatar from "../../../../../home/components/Topbar/LoggedInUser/UserAvatar/UserAvatar.component";
import {checkAuthorization} from "../../../../../../utils/Authorization/authorization";
import {AuthAPIRoutes} from "../../../../api/auth.apiRoutes";
import "./UserCard.component.scss";
import {User} from "../../../../reducers/users.reducer";
import {authStoreSelectors} from "../../../../store/store";
import {isSuperUser} from "../../../../../../utils/Authorization/authorization";

export interface UserCardProps {
    changeUserStatus: ActionCreator;
    user: User;
    filters: object;
    open_pop_up: any;
    subsidiariesLoading: boolean;
    subsidiaries: any;
}

export interface UserCardState {
    user_status: string;
}

class UserCard extends Component<UserCardProps, UserCardState> {
    constructor(props) {
        super(props);
        this.state = {
            user_status: "Inactive"
        };
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleCardEditButtonClick =
            this.handleCardEditButtonClick.bind(this);
    }

    componentDidMount() {
        let user_status = "Inactive";
        if (this.props.user.is_active) {
            user_status = "Active";
        }
        this.setState({user_status: user_status});
    }

    handleOnChange(user_id) {
        this.props.changeUserStatus({
            user_id: user_id,
            search_json: this.props.filters
        });
    }

    componentDidUpdate(prevProps): void {
        if (
            !prevProps ||
            JSON.stringify(prevProps.user) !== JSON.stringify(this.props.user)
        ) {
            let user_status = "Inactive";
            if (this.props.user.is_active) {
                user_status = "Active";
            }
            this.setState({user_status: user_status});
        }
    }

    handleCardEditButtonClick(e) {
        this.props.open_pop_up(e, {
            drawer_title: "Edit User",
            user_obj: this.props.user,
            form_button_name: "Save",
            user_action: "EDIT_USER"
        });
    }

    render() {
        return (
            <div className="user-card" key={"user" + this.props.user.id}>
                <div className="user-card-header">
                    <div className="user-card-header-image">
                        {this.props.user.profile_picture_b64  && this.props.user.profile_picture_b64 !== '' ? (
                            <img
                                alt={this.props.user.email}
                                src={this.props.user.profile_picture_b64.includes('data:image/png;base64')
                                    ? `${this.props.user.profile_picture_b64}`
                                    : `data:image;base64,${this.props.user.profile_picture_b64}`}
                            />
                        ) : (
                            <UserAvatar
                                size={40}
                                email={this.props.user.email}
                            />
                        )}
                    </div>
                    <div className="user-card-header-info">
                        <span className="username user-card-info block-display">
                            {this.props.user.first_name}{" "}
                            {this.props.user.last_name}
                        </span>
                        <span className="user-creation-date block-display">
                            {Moment(this.props.user.date_joined).format(
                                "DD MMMM, YYYY"
                            )}{" "}
                        </span>
                    </div>
                </div>
                <div className="user-card-body">
                    <p
                        className={
                            !this.props.user.is_active
                                ? "other-user-info inactive"
                                : "other-user-info"
                        }
                    >
                        {this.props.user.email}
                    </p>
                    <hr/>
                    <div className="card-block">
                        <label className="label">Subsidiaries</label>
                        <div className="subsidiaries-block">
                            {this.props.user.subsidiaries && this.props.user.subsidiaries.length > 0 ? (
                                this.props.user.subsidiaries.map(sub => {
                                    const subsidiary =
                                        this.props.subsidiaries.find(
                                            subd => subd.id == sub.id
                                        );
                                    if (subsidiary) {
                                        return (
                                            <div key={sub.id}>
                                                <div className="sub-icon">
                                                    {SubsidiaryUtils.subsidiaryIcon(subsidiary)}
                                                </div>
                                                <div className="messages">
                                                    <label className="label">
                                                        {subsidiary.description}
                                                    </label>
                                                </div>
                                            </div>
                                        );
                                    }
                                })
                            ) : (
                                <div className="no-subs">-</div>
                            )}
                        </div>
                    </div>
                    <hr/>
                    <div className="card-block">
                        <label className="label">Roles</label>
                        <div className="roles">
                            {isSuperUser && this.props.user.is_superuser && (
                                <div
                                    key={'admin'}
                                    className='custom-admin-user-badge'
                                >
                                    Administrator
                                </div>
                            )}
                            {this.props.user.roles && this.props.user.roles.length > 0 ? (
                                this.props.user.roles.map(role => {
                                    return (
                                        <div
                                            key={role['name']}
                                            className={
                                                !this.props.user.is_active
                                                    ? "custom-inactive-user-badge"
                                                    : "custom-active-user-badge"
                                            }
                                        >
                                            {role['name']}
                                        </div>
                                    );
                                })
                            ) : !this.props.user.is_superuser && (
                                <div className="other-user-info">
                                    -
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="user-card-footer">
                    <div className="user-card-footer-left">
                        {checkAuthorization({
                            route: AuthAPIRoutes.EDIT_USER
                        }) && (
                            <button
                                className="user-card-footer-button"
                                onClick={this.handleCardEditButtonClick}
                            >
                                Edit
                            </button>
                        )}
                    </div>
                    <div className="user-card-footer-right">
                        <span>{this.state.user_status}</span>
                        {checkAuthorization({
                            route: AuthAPIRoutes.CHANGE_USER_STATUS
                        }) && (
                            <Components.Switch
                                onClick={() =>
                                    this.handleOnChange(this.props.user.id)
                                }
                                on={this.props.user.is_active}
                                enabled
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    subsidiaries: authStoreSelectors.subsidiaries(state),
    subsidiariesLoading: authStoreSelectors.subsidiariesLoading(state)
});

const mapDispatchToProps = {
    changeUserStatus: AuthActionCreators.change_user_status
};

export default connect(mapStateToProps, mapDispatchToProps)(UserCard);
